import { useEffect, useState } from "react";

import { strCode } from "../consts";
import { notificationService, t } from "../services";

const useGroupsData = (groups) => {
  const [groupsData, setGroupsData] = useState(groups ?? []);
  const [editingGroup, setEditingGroup] = useState(null);

  useEffect(() => {
    setGroupsData(groups ?? []);
  }, [JSON.stringify(groups)]);

  const onAddGroup = (group) => {
    setEditingGroup(group);
    setGroupsData((prev) => [...prev, group]);
  };

  const onEditSave = (newGroupName, editingGroupName) => {
    if (
      newGroupName !== editingGroupName &&
      groupsData.some((group) => group.name === newGroupName)
    ) {
      notificationService.showError({
        title: t(strCode.GROUP_EDIT_ERROR),
        message: t(strCode.GROUP_ALREADY_EXIST_ERROR)
      });

      return false;
    }

    setGroupsData(
      groupsData.map((group) => {
        if (group.name === editingGroupName) {
          return { ...group, name: newGroupName };
        }

        return group;
      })
    );

    setEditingGroup(null);
    return true;
  };

  const onEditCancel = () => {
    setGroupsData((prev) => prev.filter((group) => group.name));
    setEditingGroup(null);
  };

  const onDelete = (groupName) => {
    setGroupsData(groupsData.filter((group) => group.name !== groupName));
  };

  const resetData = () => {
    setEditingGroup(null);
    setGroupsData(groups);
  };

  return {
    groupsData,
    editingGroup,
    setEditingGroup,
    onAddGroup,
    onEditSave,
    onEditCancel,
    onDelete,
    resetData
  };
};

export default useGroupsData;
